import Manager from 'coreClasses/Manager';

/**
 * Represents LockMgr
 */
class LockMgr extends Manager {
	private map: Map<string, null|Promise<any>> = new Map();

	/**
	 * Sets the lock for the given key
	 * @param {string} key - lock key
	 * @return {Promise<any>} - promise to wait for
	 */
	getLock(key: string): null|Promise<any> {
		if (this.map.has(key)) {
			return this.map.get(key);
		} else {
			return null;
		}
	}

	/**
	 * Sets the lock for the given key
	 * @param {string} key - lock key
	 * @param {Promise<any>} promise - promise to wait for
	 */
	setLock(key: string, promise: null|Promise<any>) {
		this.map.set(key, promise);
	}
}

export default LockMgr;
